<script setup lang="ts">
import { PanelTheme } from "@/common/themes";
import { tabMenu } from "@/common/components";

interface MenuListType {
  icon: string;
  label?: string;
  url?: string;
  key: string;
}

defineProps<{
  tabActive: string;
  menuList: MenuListType[];
}>();
</script>

<template>
  <panel-theme>
    <section class="page">
      <tab-menu :tabs="menuList" :active="tabActive">
        <template #title>
          <slot name="title"></slot>
        </template>

        <template #content>
          <slot name="content"></slot>
        </template>
      </tab-menu>
    </section>
  </panel-theme>
</template>

<style lang="scss" scoped>
.page {
  display: flex;
  flex-direction: column;
}
</style>